import React, { FC, useContext } from 'react'
import { Trans, t } from '@lingui/macro'
import { Text, ButtonClean, ButtonPrimary } from 'front-end/src/components'
import { Modal } from '../../components'
import { TopicDetailContext } from './TopicDetailContext'

export interface ITopicEnrolmentRestartModalProps {
  title?: string
  description?: any
  positiveCta?: React.ReactNode
  negativeCta?: React.ReactNode
  callback?: () => void
  callbackCancel?: () => void
  onHide?: () => void
}

export const TopicEnrolmentRestartModal: FC<ITopicEnrolmentRestartModalProps> =
  ({
    title,
    description,
    positiveCta,
    negativeCta,
    callback,
    callbackCancel,
    onHide
  }) => {
    const { topic, resetEnrolment } = useContext(TopicDetailContext)

    return (
      <Modal
        show={true}
        newDesign
        className="ResetTopicModal"
        header={title ? title : t`New version available`}
        onHide={() => onHide && onHide()}
        controls={
          <>
            <ButtonClean
              onClick={() => {
                callbackCancel && callbackCancel()
              }}
            >
              {negativeCta ? negativeCta : t`Cancel`}
            </ButtonClean>
            <ButtonPrimary
              onClick={async () => {
                const topicId = topic?.id
                if (topicId) {
                  await resetEnrolment()
                  callback && (await callback())
                }
              }}
            >
              {positiveCta ? positiveCta : <Trans>Get latest version</Trans>}
            </ButtonPrimary>
          </>
        }
      >
        <Text>
          {description
            ? description
            : t`Some of your progress may be maintained. A new enrolment will be created and your progress will be recalculated. Previous enrolment will be archived.`}
        </Text>
      </Modal>
    )
  }
